import React from "react";
import InfoModal from "./InfoModal";

export default ({ isOpen, toggle, msg, children }) => (
  <InfoModal {...{ isOpen, toggle, msg: msg || children }} />
);
